var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"w-100 d-none d-md-flex d-lg-flex my-auto ml-4"},[_vm._v(" "+_vm._s(_vm.consoleName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }